import { createSlice } from '@reduxjs/toolkit';
import { getFuelPrices } from '../thunks/commonInfoThunks';

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const slice = createSlice({
    name: 'fuelPrices',
    initialState,
    reducers: {
        clearFuelPrices: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFuelPrices.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getFuelPrices.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getFuelPrices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearFuelPrices } = slice.actions;

export const selectFuelPrices = (state) => state.commonData.fuelPrices.data;
export const selectFuelPricesLoading = (state) =>
    state.commonData.fuelPrices.loading;

export const fuelPrices = slice.reducer;
